// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgBusinessRigOffshoreSolid = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M5 2.5a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5H13l.681 5h1.033l4.018-5.626a.894.894 0 0 1 1.503.963L17.571 9h1.428a1 1 0 0 1 1 1v5h.363c.325 0 .561.306.482.621l-.655 2.621a1 1 0 0 1-.97.758h-1.22v3h-4v-3h-4v3H6v-3H4.78a1 1 0 0 1-.97-.757l-.655-2.622A.5.5 0 0 1 3.64 15h.86L6 4h-.5a.5.5 0 0 1-.5-.5zM11 4H8l-.41 3h3.819zm.954 7-.34-2.5H7.385L7.045 11zM6.84 12.5 6.5 15h6l-.341-2.5z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgBusinessRigOffshoreSolid;
